module.exports = __webpack_public_path__ + "media/toolkits/checkmark-bullets-8dbd7cbc.png";